import React from 'react';

/**
 * AlertBadge - Color-coded badge for medical alerts and status indicators
 * Provides consistent visual hierarchy for clinical priorities
 */
interface AlertBadgeProps {
  type: 'critical' | 'warning' | 'info' | 'success';
  children: React.ReactNode;
  icon?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const AlertBadge: React.FC<AlertBadgeProps> = ({
  type,
  children,
  icon,
  size = 'md',
  className = ''
}) => {
  const baseClasses = 'inline-flex items-center font-medium rounded-full';
  
  const typeClasses = {
    critical: 'bg-red-100 text-red-800 border border-red-200',
    warning: 'bg-yellow-100 text-yellow-800 border border-yellow-200',
    info: 'bg-blue-100 text-blue-800 border border-blue-200',
    success: 'bg-green-100 text-green-800 border border-green-200'
  };

  const sizeClasses = {
    sm: 'px-2 py-1 text-xs',
    md: 'px-2.5 py-1.5 text-sm',
    lg: 'px-3 py-2 text-base'
  };

  const badgeClasses = `${baseClasses} ${typeClasses[type]} ${sizeClasses[size]} ${className}`;

  return (
    <span className={badgeClasses}>
      {icon && (
        <span className="mr-1" role="img" aria-hidden="true">
          {icon}
        </span>
      )}
      {children}
    </span>
  );
};

export default AlertBadge;